import React, { useEffect, useMemo, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

import { Logo } from '../App/Components'
import { IMenuActivity } from '../Menu/Store/IMenuActivity'
import { useHistory, useParams } from '../Router'

import { useAppDispatch, useAppSelector } from '../store/hooks'
import { CustomerForm } from '../CustomerForm/CustomerForm'
import { StyledScrollView } from '../App/Components/AppContainer'
import { CustomerFormData } from '../CustomerForm/ICustomerFormData'
import { setCustomerFormData } from '../Appointment/store/Actions'
import { ServiceTitle } from '../Appointment/style'
import { usePricePreview } from '../PunchCard/usePricePreview'

export const BookAppointment = () => {
  const { establishmentId } = useParams<{ establishmentId: string }>()
  const dispatch = useAppDispatch()
  const history = useHistory()
  const { t } = useTranslation()

  const appointment = useAppSelector((state) => state.appointment)
  const settingsState = useAppSelector((state) => state.settings)

  const { customers, customerPunchCardUuids, date } = appointment

  const activities: IMenuActivity[] = useMemo(
    () => customers.map((a) => a.activities).flat(1),
    [customers]
  )

  const appointmentDate = date ? moment(date).format('YYYY-MM-DD') : undefined

  // The deposit must reflect punch-card matches: when a punch card covers the
  // selected services the price-preview reports a deposit of 0. Relying on the
  // static per-activity deposit in Redux would wrongly show a deposit notice
  // for punch-card-covered services (OB-512).
  const preview = usePricePreview(
    settingsState.values?.uuid,
    establishmentId,
    customers,
    appointmentDate,
    customerPunchCardUuids
  )

  useEffect(() => {
    if (activities.length === 0) {
      history.push(`/${establishmentId}`)
    }
  }, [activities.length, history, establishmentId])

  const handleSubmit = useCallback(
    (customerData: CustomerFormData) => {
      dispatch(setCustomerFormData(customerData))
      history.push(`/${establishmentId}/appointment/confirm`)
    },
    [dispatch, history, establishmentId]
  )

  return (
    <StyledScrollView>
      <Logo />
      <ServiceTitle fontcolor={settingsState.values?.fontColor}>
        {t('Contact information')}
      </ServiceTitle>
      <CustomerForm
        submitHandler={handleSubmit}
        deposit={preview.totalDeposit}
        confirmButtonText="Next"
      />
    </StyledScrollView>
  )
}
